<template>
    <div class="flex w-full h-full p-2 contrast-dark-400">
        <div class="w-full p-4">
            <img :src="getIcon(quiz_chosen.name)" :alt="quiz_chosen.name" class="h-6 w-6 inline-block mb-2 mr-2 rounded">
            <span class="text-2xl">{{quiz_chosen.name}}</span>
            <hr class="border-dark-100 mt-1">
            <p class="font-bold" v-if="quiz_chosen.description">{{quiz_chosen.description}}</p>
            <ol class="list-decimal list-inside font-light">
                <router-link
                        v-for="(theme, index) in quiz_chosen.themes"
                        tag="li"
                        class="p-3 cursor-pointer leading-5 border border-dark-100 rounded my-2"
                        :to="'/ask/'+quiz_chosen.id+'/'+theme.id"
                        :key="index"
                >
                    <span :class="theme.type==='main' ? '':'text-warning-500'">{{theme.name}}</span>
                </router-link>
            </ol>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'home',
    data() {
      return {

      }
    },
    computed: {
        ...mapGetters('profile',['logged_user']),
        quiz_chosen(){
            if(!this.$route.params.quiz_id){
                return null;
            }
            return this.logged_user.quizzes.find(quiz=>Number(quiz.id)===Number(this.$route.params.quiz_id));
        }
    },
    methods: {

    },
    mounted() {

    }
  }
</script>
